<ng-container *transloco="let t">
  <section
    *ngIf="status && !loading"
    class="order-tracking-status popsy-card"
    [class.mobile]="(biggerThan$ | async)?.xs === true"
    [class.widescreen]="(biggerThan$ | async)?.sm === true">
    <span class="fixed-space-24" aria-hidden="true"></span>
    <div class="header">
      <h3>{{ t('label_track_status') }}</h3>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <span class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <span class="whitespace">{{ t('label_track_estimate_text') }}</span>
    </div>
    <span class="fixed-space-32" aria-hidden="true"></span>

    <div class="package" *ngFor="let package of packages; trackBy: trackByPackage">
      <span class="fixed-space-16" aria-hidden="true"></span>
      <!-- Delivering status -->
      <ul
        class="package-cont"
        *ngIf="getOrderPlaced(package.orderState)"
        [class.multi]="(packages?.length || 1) > 1"
        [class.mobileXl]="(biggerThan$ | async)?.xs">
        <li class="thumb" *ngIf="(packages?.length || 1) > 1">
          <span class="fixed-space-16" aria-hidden="true"></span>
          <app-picture [pictureUrl]="getPackageImage(package.order)"></app-picture>
          <span class="fixed-space-32" aria-hidden="true"></span>
        </li>
        <div class="status-list">
          <li
            class="row order-placed"
            [class.active]="getOrderPlaced(package.orderState)">
            <strong class="name">{{
              t('title_track_delivery_satatus_unconfirmed')
            }}</strong>
            <span class="icon-wrapper" aria-hidden="true">
              <popsy-icon-check-1
                class="tick-icon"
                *ngIf="getOrderPlaced(package.orderState)"></popsy-icon-check-1>
            </span>
            <strong class="name">{{
              t('title_track_delivery_satatus_unconfirmed')
            }}</strong>
          </li>
          <ng-container *ngIf="getPendingPayment(package.orderState) as pendingPayment">
            <span class="line" aria-hidden="true"></span>
            <li class="row delivered" [class.active]="pendingPayment">
              <strong class="name">{{
                t('title_delivery_status_waiting_payment')
              }}</strong>
              <span class="icon-wrapper" aria-hidden="true">
                <popsy-icon-check-1
                  class="tick-icon"
                  *ngIf="pendingPayment"></popsy-icon-check-1>
              </span>
              <strong class="name">{{
                t('title_delivery_status_waiting_payment')
              }}</strong>
            </li>
          </ng-container>

          <span class="line split" aria-hidden="true"></span>
          <li
            class="row confirmed-by-seller"
            [class.active]="getOrderConfirmed(package.orderState)">
            <strong class="name">{{ t('title_track_delivery_status_confirmed') }}</strong>
            <span class="icon-wrapper" aria-hidden="true">
              <popsy-icon-check-1
                class="tick-icon"
                *ngIf="getOrderConfirmed(package.orderState)"></popsy-icon-check-1>
            </span>
            <strong class="name">{{ t('title_track_delivery_status_confirmed') }}</strong>
          </li>

          <span class="line split" aria-hidden="true"></span>
          <li class="row delivering" [class.active]="getInDelivery(package.orderState)">
            <strong class="name">{{
              t('title_track_delivery_satatus_delivering')
            }}</strong>
            <span class="icon-wrapper" aria-hidden="true">
              <popsy-icon-check-1
                class="tick-icon"
                *ngIf="getInDelivery(package.orderState)"></popsy-icon-check-1>
            </span>
            <strong class="name">{{
              t('title_track_delivery_satatus_delivering')
            }}</strong>
          </li>

          <span class="line split" aria-hidden="true"></span>
          <ng-container *ngIf="!orderFailed">
            <li class="row delivered" [class.active]="getDelivered(package.orderState)">
              <strong class="name">{{
                t('title_track_delivery_satus_delivered')
              }}</strong>
              <span class="icon-wrapper" aria-hidden="true">
                <popsy-icon-check-1
                  class="tick-icon"
                  *ngIf="getDelivered(package.orderState)"></popsy-icon-check-1>
              </span>
              <strong class="name">{{
                t('title_track_delivery_satus_delivered')
              }}</strong>
            </li>
          </ng-container>
          <span *ngIf="orderFailed" class="line split" aria-hidden="true"></span>
          <ng-container *ngIf="orderFailed">
            <li class="row calcelled" [class.error]="orderFailed">
              <strong class="name">{{ t('msg_title_delivery_status_cancelled') }}</strong>
              <span class="icon-wrapper" aria-hidden="true">
                <popsy-icon-check-1 class="icon" *ngIf="orderFailed"></popsy-icon-check-1>
              </span>
            </li>
          </ng-container>

          <span
            *ngIf="(biggerThan$ | async)?.xs"
            class="fixed-space-48"
            aria-hidden="true"></span>
        </div>
      </ul>
      <!-- Returning status -->
      <ul
        class="status-list"
        *ngIf="getOrderInReturn(package.orderState)"
        [class.multi]="(packages?.length || 1) > 1">
        <li class="thumb" *ngIf="(packages?.length || 1) > 1">
          <span class="fixed-space-16" aria-hidden="true"></span>
          <app-picture [pictureUrl]="getPackageImage(package.order)"></app-picture>
          <span class="fixed-space-32" aria-hidden="true"></span>
        </li>
        <li class="row confirmed-by-seller" [class.active]="true">
          <strong class="name">{{ t('title_track_delivery_status_confirmed') }}</strong>
          <span class="icon-wrapper" aria-hidden="true">
            <popsy-icon-check-1 class="tick-icon"></popsy-icon-check-1>
          </span>
          <strong class="name">{{ t('title_track_delivery_status_confirmed') }}</strong>
        </li>

        <span class="line split" aria-hidden="true"></span>
        <li
          class="row order-placed"
          [class.active]="getOrderInReturn(package.orderState)">
          <strong class="name">{{ t('title_track_delivery_status_returning') }}</strong>
          <span class="icon-wrapper" aria-hidden="true">
            <popsy-icon-check-1
              class="tick-icon"
              *ngIf="getOrderInReturn(package.orderState)"></popsy-icon-check-1>
          </span>
          <strong class="name">{{ t('title_track_delivery_status_returning') }}</strong>
        </li>

        <span class="line split" aria-hidden="true"></span>
        <li
          class="row confirmed-by-seller"
          [class.active]="getReturned(package.orderState)">
          <strong class="name">{{ t('title_track_delivery_status_returned') }}</strong>
          <span class="icon-wrapper" aria-hidden="true">
            <popsy-icon-check-1
              class="tick-icon"
              *ngIf="getReturned(package.orderState)"></popsy-icon-check-1>
          </span>
          <strong class="name">{{ t('title_track_delivery_status_returned') }}</strong>
        </li>

        <span
          *ngIf="(biggerThan$ | async)?.xs"
          class="fixed-space-48"
          aria-hidden="true"></span>
      </ul>
      <!-- TRACKING LINK -->
      <div
        *ngIf="package.trackingUrl && package.trackingUrl !== 'test-url'"
        class="tracking-link">
        <span class="fixed-space-12" aria-hidden="true"></span>
        <a
          class="popsy-button-primary pill cta highlight outlined margin-centered"
          [href]="package.trackingUrl"
          target="_blank">
          {{ t('action_follow_shipment') }}
        </a>
        <span class="fixed-space-12" aria-hidden="true"></span>

        <span class="tracking-link" *ngIf="package?.trackingAWB">
          {{ t('action_code_shipment') }} {{ package?.trackingAWB }}
        </span>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </div>

    <ng-container *ngIf="orderFailed">
      <span class="fixed-space-16" aria-hidden="true"></span>

      <div class="order-cancelled-disclamer">
        {{ t('msg_delivery_status_buyer_cancelled') }}
      </div>
    </ng-container>
    <span class="fixed-space-24" aria-hidden="true"></span>
  </section>
  <section *ngIf="!status || loading" class="skeleton order-tracking-status">
    <div class="skeleton header">
      <popsy-skeleton class="skeleton title"></popsy-skeleton>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <ul class="skeleton status-list">
      <li class="skeleton row order-placed">
        <popsy-skeleton class="skeleton icon-wrapper"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <popsy-skeleton class="skeleton name"></popsy-skeleton>
      </li>
      <span class="fixed-space-24" aria-hidden="true"></span>
      <li class="skeleton row confirmed-by-seller">
        <popsy-skeleton class="skeleton icon-wrapper"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <popsy-skeleton class="skeleton name"></popsy-skeleton>
      </li>
      <span class="fixed-space-24" aria-hidden="true"></span>
      <li class="skeleton row delivering">
        <popsy-skeleton class="skeleton icon-wrapper"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <popsy-skeleton class="skeleton name"></popsy-skeleton>
      </li>
      <span class="fixed-space-24" aria-hidden="true"></span>
      <li class="skeleton row delivered">
        <popsy-skeleton class="skeleton icon-wrapper"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <popsy-skeleton class="skeleton name"></popsy-skeleton>
      </li>
    </ul>
    <span class="fixed-space-24" aria-hidden="true"></span>
  </section>
</ng-container>
